import { render, staticRenderFns } from "./PaypalDefault.vue?vue&type=template&id=240ac06a&"
import script from "./PaypalDefault.vue?vue&type=script&lang=js&"
export * from "./PaypalDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports